import React from 'react';
import Form from 'react-bootstrap/Form';
import RichText from '../controls/RichText';
import NumericInput from 'react-numeric-input';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { Content, Component } from '../DataStructures';
import { useForceUpdate, getRawText, isValidURL } from '../util';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
import { TabContextReporter } from '../TabContext';
export default function FigureList(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Figure Information"
  }, /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Caption:"), " ", /*#__PURE__*/React.createElement("i", null, "A figurative description of the image.")), /*#__PURE__*/React.createElement(RichText, {
    value: dataProps.caption,
    onChange: v => {
      dataProps.caption = v;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image Credit")), /*#__PURE__*/React.createElement(RichText, {
    noWapper: true,
    value: dataProps.photoCredit,
    onChange: v => {
      dataProps.photoCredit = v;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Number of Images:")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NumericInput, {
    min: 1,
    max: 6,
    value: props.data.children.length,
    onChange: e => {
      if (e) {
        let delta = e - props.data.children.length;
        if (delta > 0) {
          for (let i = 0; i < Math.abs(delta); ++i) {
            props.data.children.push(new Component({
              tagName: 'FigureList.Item',
              props: {
                src: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg",
                alt: "A literal description of the image.",
                longAlt: new Content("A longer description of the image.")
              }
            }));
          }
        } else if (delta < 0) {
          for (let i = 0; i < Math.abs(delta); ++i) {
            props.data.children.pop();
          }
        }
        forceUpdate();
        props.onChanged();
      }
    }
  }))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Component Max Height:")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NumericInput, {
    min: 1,
    max: 562,
    value: parseInt(dataProps.imgHeight),
    onChange: e => {
      if (e) {
        dataProps.imgHeight = e + "px";
        forceUpdate();
        props.onChanged();
      }
    }
  }))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Align:")), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(DropdownButton, {
    title: dataProps.placeContent
  }, ["start", "center", "end"].map((v, k) => {
    return /*#__PURE__*/React.createElement(Dropdown.Item, {
      key: k,
      onClick: () => {
        dataProps.placeContent = v;
        forceUpdate();
        props.onChanged();
      }
    }, v);
  })))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Flex Direction:")), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(DropdownButton, {
    title: dataProps.flexDirection
  }, ["row", "column"].map((v, k) => {
    return /*#__PURE__*/React.createElement(Dropdown.Item, {
      key: k,
      onClick: () => {
        dataProps.flexDirection = v;
        forceUpdate();
        props.onChanged();
      }
    }, v);
  }))))))), props.data.children.map((v, k) => {
    var _props$data$children$;
    if (props.data.children[k].props.height === undefined) {
      props.data.children[k].props.height = dataProps.imgHeight;
    }
    return /*#__PURE__*/React.createElement(TabContextReporter, {
      key: k + 1,
      index: k + 1 + "",
      title: `Image ${k + 1}`
    }, /*#__PURE__*/React.createElement(FormValidityProvider, {
      onChange: props.onValidityChange
    }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image URL:"), " ", /*#__PURE__*/React.createElement("i", null, "A direct link to the image.")), /*#__PURE__*/React.createElement(Form.Control, {
      as: "textarea",
      value: props.data.children[k].props.src,
      onChange: e => {
        props.data.children[k].props.src = e.target.value;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: isValidURL(props.data.children[k].props.src)
    }, "Please type in a valid URL.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Alt Text:"), " ", /*#__PURE__*/React.createElement("i", null, "A literal description of the image.")), /*#__PURE__*/React.createElement(Form.Control, {
      as: "textarea",
      value: props.data.children[k].props.alt,
      onChange: e => {
        props.data.children[k].props.alt = e.target.value;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: props.data.children[k].props.alt.length > 0
    }, "Images must have alt text."), /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: dataProps.alt.length <= 140
    }, "Alt text should generally be less than 140 characters.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Long Alt Text:"), " ", /*#__PURE__*/React.createElement("i", null, "A longer description of the image (optional).")), /*#__PURE__*/React.createElement(RichText, {
      value: props.data.children[k].props.longAlt,
      onChange: v => {
        props.data.children[k].props.longAlt = v;
        forceUpdate();
        props.onChanged();
      }
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image Height:")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NumericInput, {
      min: 10,
      max: parseInt(dataProps.imgHeight),
      value: parseInt((_props$data$children$ = props.data.children[k].props) === null || _props$data$children$ === void 0 ? void 0 : _props$data$children$.height),
      onChange: e => {
        if (e) {
          props.data.children[k].props.height = e + "px";
          forceUpdate();
          props.onChanged();
        }
      }
    }))))));
  }));
}